var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-b-30"},[_c('DetailPure',{attrs:{"detail":_vm.detail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }